/**
 * Close mobile tabs menu when something else is clicked
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/prop/prop.js";

export default obj => {
	if (obj.length) {
		$(document).on("click", e => {
			const target = $(e.target);
			if (!target.is("label[for=" + target.attr("id") + "]") && !target.is(obj) && obj.is(":checked")) {
				obj.prop("checked", "");
			}
		});
	}
};
